import { isDevLikeEnvironment, isLocalEnvironment, isRuntimeFederation, } from "@aviv-unified-frontend/internal";
import pkg from "../../package.json" with { type: "json" };
export const BRAND = process.env.BRAND;
export const ENVIRONMENT = process.env.ENVIRONMENT;
export const VERSION_EPHEMERAL = process.env.VERSION_EPHEMERAL ?? "";
export const VERSION = VERSION_EPHEMERAL ||
    (ENVIRONMENT === "live" ? pkg.version : `${pkg.version}-next`);
export const DEV_ENVIRONMENT = "dev";
export const PREVIEW_ENVIRONMENT = "preview";
export const LIVE_ENVIRONMENT = "live";
export const STAGE_LIKE_ENVIRONMENT = isLocalEnvironment(ENVIRONMENT)
    ? "dev"
    : ENVIRONMENT;
export const IS_LOCAL_ENVIRONMENT = isLocalEnvironment(ENVIRONMENT);
export const IS_DEV_LIKE_ENVIRONMENT = isDevLikeEnvironment(ENVIRONMENT);
export const IS_RUNTIME_FEDERATION = isRuntimeFederation(ENVIRONMENT);
export const ALLOW_RUNTIME_FEDERATION_VERSION_OVERLOADING = IS_RUNTIME_FEDERATION && isDevLikeEnvironment(ENVIRONMENT);
export const DEPLOYMENT_FOOTPRINT = isDevLikeEnvironment(ENVIRONMENT) && process.env.DEPLOYMENT_FOOTPRINT;
